export const HEIGHT = 48;
export const BANNER_NAME = 'EOC_TRANSITION' as const;
